import * as swcHelpers from '@swc/helpers';
import React__default, { forwardRef } from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const addLinkToComponent = (component, href)=>{
    if (href) {
        return /*#__PURE__*/ React__default.createElement("a", {
            className: "elements-line-item-media__link",
            href: href
        }, component);
    }
    return component;
};
const LineItemMedia = /*#__PURE__*/ forwardRef((_param, ref)=>{
    var { href , children , className , imageUrl , imageAlt , iconName , iconLabel , type , overlayElement , width  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "href",
        "children",
        "className",
        "imageUrl",
        "imageAlt",
        "iconName",
        "iconLabel",
        "type",
        "overlayElement",
        "width"
    ]);
    const containerClasses = classnames('elements-line-item-media__container', {
        'elements-line-item-media__container--with-overlay': !!overlayElement
    });
    let content = children;
    if (!content) {
        if (type === 'image') {
            content = /*#__PURE__*/ React__default.createElement("div", {
                className: containerClasses
            }, /*#__PURE__*/ React__default.createElement("img", {
                className: classnames('elements-line-item-media__image', {
                    [`elements-line-item-media__image--${width}`]: width,
                    [`${className}__image`]: className
                }),
                src: imageUrl,
                alt: imageAlt
            }));
        }
        if (type === 'icon' && iconName) {
            content = /*#__PURE__*/ React__default.createElement("div", {
                className: containerClasses
            }, /*#__PURE__*/ React__default.createElement("div", {
                className: "elements-line-item-media__icon"
            }, /*#__PURE__*/ React__default.createElement(Icon, {
                name: iconName,
                width: 48,
                height: 48
            }), !!iconLabel && /*#__PURE__*/ React__default.createElement("span", {
                className: "elements-line-item-media__icon-label"
            }, iconLabel)));
        }
    }
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('elements-line-item-media', className),
        ref: ref
    }), addLinkToComponent(content, href));
});
LineItemMedia.displayName = 'LineItemMedia';
var LineItemMedia$1 = LineItemMedia;

export { LineItemMedia$1 as default };
//# sourceMappingURL=LineItemMedia.js.map
